import React, {useMemo} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    root: {
        textAlign: 'center',
    },
    text: {
        paddingTop: props => theme.spacing(1),
        paddingBottom: props => theme.spacing(1) + 3,
        borderStyle: 'solid',
        borderColor: props => theme.palette.primary.main,
        borderWidth: '0 0 1px 1px'

    },
    currentText: {
        //fontWeight: theme.typography.fontWeightBold,
        borderBottomWidth: 4,
        paddingBottom: props => theme.spacing(1)
    },
    linkText: {
        cursor: "pointer"
    }
}))

function StageElement(
    {
        current,
        onClick,
        thin,
        children
    }) {
    const classes = useStyle({thin});
    const color = useMemo(() => Boolean(onClick) ? 'textPrimary' : 'textSecondary', [onClick])

    return (
        <div className={classes.root}>
            <Typography
                variant='body1'
                className={clsx(classes.text, {
                    [classes.currentText]: current,
                    [classes.linkText]: !current && Boolean(onClick)
                })}
                onClick={() => {
                    if (Boolean(onClick)) {
                        onClick();
                    }
                }}
                color={color}
            >
                {children}
            </Typography>
        </div>
    )
}

StageElement.propTypes = {
    classes: PropTypes.any,
}

export default StageElement;